import { Calculator, Leaf, Megaphone,Shield, TrendingUp } from "lucide-react";

import type { VpSlug } from "@/5-shared/types";

export type { VpSlug };

/**
 * The five buyer value propositions. Single source of truth for the
 * companies bento, the "Soluzioni" nav dropdown, and the solution pages
 * at /companies/solutions/<slug>.
 *
 * The `slug` keys the localised copy (`nav.solutionLabels.<slug>` for the title,
 * `nav.solutionCategories.<slug>` for the chip, both in `common`) and picks the
 * thumbnail behind each bento card (`2-sections/bento/CompaniesBento`).
 */
type ValueProp = {
  slug: VpSlug;
  icon: typeof Shield;
  span: string;
};

export const VALUE_PROPS: ValueProp[] = [
  { slug: "riduzione-prevedibile", icon: Calculator, span: "lg:col-span-2" },
  { slug: "conformita", icon: Leaf, span: "lg:col-span-1" },
  { slug: "ebitda", icon: TrendingUp, span: "lg:col-span-1" },
  { slug: "copertura-naturale", icon: Shield, span: "lg:col-span-1" },
  { slug: "impatto", icon: Megaphone, span: "lg:col-span-1" },
];

export const solutionPath = (p: ValueProp) => `/company/solutions/${p.slug}`;
